<template>
  <div>
    <div class="popup-notification">
      <b-alert
        fade
        v-bind:variant="type"
        :show="show"
        dismissible
        @dismissed="dismissPopup"
        v-text="message"
      />
    </div>
  </div>
</template>

<script>
import { BAlert } from "bootstrap-vue";
// import { setInterval } from "timers";
export default {
  name: "alert-popup",
  data() {
    return {
      dismissSecs: 3,
      dismissCountDown: 0,
      showDismissibleAlert: false,
    };
  },
  components: {
    BAlert,
  },
  props: ["show", "type", "message"],
  mounted() {
    //this.autoClosePopup();
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    dismissPopup() {
      this.dismissCountDown = 0;
      // this.$store.commit("resetAlert");
      this.$showAlert = false;
      setTimeout(() => {
        this.$store.commit("notifications/resetAlert");
      }, 100);
      // this.show = false;
      // let Popup = document.querySelector(".popup-notification");
      // Popup.remove();
    },
  },
};
</script>

<style lang="scss" scoped>
/*.popup-notification{height:100vh;width:100%; position: fixed;left: 0;height: 100%;width: 100%;top: 0;z-index: 99;display: flex;align-items: flex-start;justify-content: flex-end;}
.popup-notification:before{ content:''; background:rgba(51, 51, 51, 0.60); position:absolute; left:0; top:0; height:100%;width:100%}*/
.popup-notification .alert-success {
  color: #fff;
  background-color: $success-btn;
  border-color: #509c63;
}
// .popup-notification {
//   height: 100vh;
//   width: 100%;
//   left: 0;
//   height: 100%;
//   width: 100%;
//   display: flex;
//   align-items: flex-start;
//   justify-content: flex-end;
//   // position: fixed;
//   //   z-index: 9999;
// }

.popup-notification {
  .alert {
    position: absolute;
    z-index: 99999;
    transform: translate(-50%);
    left: 50%;
    /*margin: 38px 0px 0px 0;
    min-width: 380px;*/
    padding: 1.1rem 1.5rem;
    // top: 0px; transition: all .3s ease-out;
    // -webkit-animation: slide .3s ease-out;
    // animation: slide .3s ease-out;
    width: max-content;
    font-size: 15px;
    border: 0;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5), 0 1px 1px 0 rgba(0, 0, 0, 0.25);
    animation: slide 0.3s forwards;
    bottom: 0;
  }
  @keyframes slide {
    100% {
      bottom: 1rem;
    }
  }
}
</style>
